import gql from 'graphql-tag'

export const UPDATE_ACCOMMODATION_PRICE_CELLS = gql`
  mutation ($toPrice: Int!, $cells: [UpdateAccommodationPriceCellsInput!]!) {
    updateAccommodationPriceCells(toPrice: $toPrice, cells: $cells)
  } # Write your query or mutation here
`
